import { useSyncExternalStore } from 'react';
import { JABBERR_AVATARS } from '@jabberr/core';
export const AVATARS = JABBERR_AVATARS;
let personal = 'professional';
const listeners = new Set<() => void>();
export function setPersonalAppearance(id: string) { personal = AVATARS.some(a => a.id === id) ? id : 'professional'; listeners.forEach(fn => fn()); }
export function usePersonalAppearance() { return useSyncExternalStore(fn => { listeners.add(fn); return () => { listeners.delete(fn); }; }, () => personal); }
export function avatarUrl(id: string) { return (AVATARS.find(a => a.id === id) ?? AVATARS[0]).imageUrl; }

let sharedAppearance: string | null = null;
const sharedListeners = new Set<() => void>();
export function setSharedAppearance(id: string | null) { sharedAppearance = id; sharedListeners.forEach(fn => fn()); }
export function useSharedAppearance() { return useSyncExternalStore(fn => { sharedListeners.add(fn); return () => { sharedListeners.delete(fn); }; }, () => sharedAppearance); }
